import { render, staticRenderFns } from "./KgjtWebsiteProductRecommend.vue?vue&type=template&id=3f042208&scoped=true&"
import script from "./KgjtWebsiteProductRecommend.vue?vue&type=script&lang=js&"
export * from "./KgjtWebsiteProductRecommend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f042208",
  null
  
)

export default component.exports